import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { PartySummaryModel } from '../../models/party-summary.model';
@Component({
  selector: 'jsg-jsc-action-summary-view',
  templateUrl: './jsc-action-summary-view.component.html',
  styleUrls: ['./jsc-action-summary-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JscActionSummaryViewComponent implements OnInit {
  @Input() actionInfoHeading: string;
  @Input() showEditButton: boolean = false;
  @Input() displayedColumns: string[];
  @Input() partySummary: PartySummaryModel[];
  @Output() editButtonClick = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}
}
